import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
	BUTTON_CLOSE: '[data-fragment="ModalComponent.buttonClose"]',
};

class ModalComponent extends WebComponent {
	constructor(props) {
		super(props);
		const {
			show = false,
		} = props;
		this.state = {
			show,
		};
	}
	didMount() {
		this.on('click',fragments.BUTTON_CLOSE, this.handleClickOnLink);
	}


	handleClickOnLink = (e) => {
		e.preventDefault();
		const {
			show,
		} = this.state;

		this.setState({
			show: !show,
		});
		classNames(document.body, {
			'modal__open': false,
		});
		classNames(this.element, {
			'modal--open': false,
		});
	}

	willUnMount() {
		this.itemElement = null;
	}
	update(prevProps, prevState, inDocument) {
		const {
			show,
		} = this.state;

	}
}

export default ModalComponent;




// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/ModalComponent/ModalComponent.js